import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsItFor() {
  const forWho = ['Adultos profesionales que se sienten estancados a pesar de tener el talento necesario.', "Estudiantes que dejan todo para el último minuto y viven en un ciclo eterno de estrés y 'crunch'.", "Personas con TDAH (diagnosticadas o no) que están cansadas de sentirse culpables por su 'falta de voluntad'.", 'Creativos que tienen mil ideas pero no logran aterrizar ninguna.'];
  const notForWho = ["Personas que buscan una 'cura' para el TDAH (esto es una herramienta de gestión, no un fármaco).", "Quienes buscan optimización de rendimiento tipo 'Biohackers' sin tener problemas reales de inicio de tarea.", 'Quienes esperan que el libro haga el trabajo por ellos sin aplicar los cambios en su entorno.'];
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-207">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12" data-id="element-208">
        <FadeIn data-id="element-209">
          <div className="bg-slate-800/30 border border-emerald-500/20 rounded-3xl p-8 md:p-10 h-full" data-id="element-210">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-8 flex items-center gap-3" data-id="element-211">
              <span className="text-emerald-400" data-id="element-212">Para ti</span> si...
            </h3>
            <ul className="space-y-6" data-id="element-213">
              {forWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-214">
                  <CheckCircle2 className="w-6 h-6 text-emerald-400 flex-shrink-0 mt-1" data-id="element-215" />
                  <span className="text-slate-300 text-lg leading-relaxed" data-id="element-216">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-217">
          <div className="bg-slate-800/30 border border-red-500/20 rounded-3xl p-8 md:p-10 h-full" data-id="element-218">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-8 flex items-center gap-3" data-id="element-219">
              <span className="text-red-400" data-id="element-220">No es para ti</span> si...
            </h3>
            <ul className="space-y-6" data-id="element-221">
              {notForWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-222">
                  <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-223" />
                  <span className="text-slate-400 text-lg leading-relaxed" data-id="element-224">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}